<template>
    <div>
        <div class="p-2">
            <modal id="add-product" ref="modal">
                <div slot="title">
                    {{ t('pdv-modal_title') }}
                </div>
                <div slot="body">
                    <div class="form">
                        <div class="form-group">
                            <label>{{ t('pdv-unit_price') }}</label>
                            <input type="number" class="form-control">
                        </div>
                        <div class="form-group">
                            <label>{{ t('pdv-quantity') }}</label>
                            <input type="number" class="form-control">
                        </div>
                        <div><strong>{{ t('pdv-subtotal_with_colon') }} </strong>
                            <div class="badge badge-secondary">{{ formatCurrency(100) }}</div>
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <button class="btn btn-outline-secondary" @click="closeProductModal()">{{ t('pdv-cancel') }}</button>
                    <button class="btn btn-primary" @click="addProduct()">{{ t('pdv-add') }}</button>
                </div>
            </modal>
            <div class="clients" v-if="step==='client'">
                <div class="blocks">
                    <div class="input-button">
                        <input type="text" class="form-control" v-model="client" :placeholder="t('pdv-client_search_placeholder')">
                        <button class="btn-primary btn-small btn">{{ t('pdv-add') }}</button>
                    </div>
                    <div class="clients">
                        <button class="client" @click="step='products'">
                            <div><strong>{{ t('pdv-client_1') }}</strong></div>
                            <div>(48) 99959-4159</div>
                        </button>
                        <button class="client" @click="step='products'">
                            <div><strong>{{ t('pdv-client_2') }}</strong></div>
                            <div>(48) 99959-4159</div>
                        </button>
                        <button class="client" @click="step='products'">
                            <div><strong>{{ t('pdv-client_3') }}</strong></div>
                            <div>(48) 99959-4159</div>
                        </button>
                    </div>
                </div>
            </div>
            <div class="products" v-if="step==='products'">
                <div class="blocks previous">
                    <div class="client" @click="step='client'">
                        <div><strong>{{ t('pdv-client_1') }}</strong></div>
                        <div>(48) 99959-4159</div>
                    </div>
                </div>

                <div class="blocks">
                    <div class="input-button">
                        <input type="text" class="form-control box add-product" v-model="productsSearch"
                               :placeholder="t('pdv-product_search_placeholder')">
                    </div>
                    <div class="products">
                        <button class="client" @click="openProductModal()">
                            <div><strong>{{ t('pdv-product_1') }}</strong></div>
                            <div>{{ formatCurrency(10) }}</div>
                        </button>
                        <button class="client" @click="openProductModal()">
                            <div><strong>{{ t('pdv-product_2') }}</strong></div>
                            <div>{{ formatCurrency(10) }}</div>
                        </button>
                        <button class="client" @click="openProductModal()">
                            <div><strong>{{ t('pdv-product_3') }}</strong></div>
                            <div>{{ formatCurrency(10) }}</div>
                        </button>
                    </div>
                </div>
            </div>
            <div class="products" v-if="step==='products-list'">
                <div class="blocks previous">
                    <div class="client" @click="step='client'">
                        <div><strong>{{ t('pdv-client_1') }}</strong></div>
                        <div>(48) 99959-4159</div>
                    </div>
                </div>

                <div class="blocks">
                    <div class="products-table">
                        <table class="table table-stripped">
                            <tr>
                                <th>{{ t('pdv-product') }}</th>
                                <th>{{ t('pdv-quantity') }}</th>
                                <th>{{ t('pdv-subtotal') }}</th>
                            </tr>
                            <tr v-for="product in products">
                                <td>{{ product.name }}</td>
                                <td>{{ product.quantity }}</td>
                                <td>{{ formatCurrency(product.subtotal) }}</td>
                            </tr>
                            <tr class="total-row">
                                <td></td>
                                <td>{{ t('pdv-total') }}</td>
                                <td>{{ formatCurrency(total) }}</td>
                            </tr>
                            <tr>
                                <td colspan="3" class="text-center">
                                    <div class="btn btn-primary btn-small" @click="step='products'">
                                        {{ t('pdv-add_product') }}
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary btn-lg main-cta" @click="step='payment'">
                            {{ t('pdv-advance_payment') }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="payment" v-if="step==='payment'">
                <div class="blocks previous">
                    <div class="client" @click="step='client'">
                        <div><strong>{{ t('pdv-client_1') }}</strong></div>
                        <div>(48) 99959-4159</div>
                    </div>
                </div>
                <div class="blocks previous products" @click="step='products'">
                    <table class="table table-striped table-responsive">
                        <tr>
                            <th>{{ t('pdv-product') }}</th>
                            <th>{{ t('pdv-quantity') }}</th>
                            <th>{{ t('pdv-subtotal') }}</th>
                        </tr>
                        <tr v-for="product in products">
                            <td>{{ product.name }}</td>
                            <td>{{ product.quantity }}</td>
                            <td>{{ formatCurrency(product.subtotal) }}</td>
                        </tr>
                    </table>
                </div>

                <div class="payment-block">
                    <div class="blocks">
                        <div>
                            <div>
                                <label>{{ t('pdv-coupon') }}</label>
                            </div>
                            <div class="input-button">
                                <input type="text" class="form-control">
                                <button class="btn btn-primary btn-small">{{ t('pdv-apply') }}</button>
                            </div>
                        </div>
                        <div>
                            <div>
                                <label>{{ t('pdv-total') }}</label>
                            </div>
                            <div class="input-button">
                                <input type="text" class="form-control" v-model="total">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center">
                    <button class="btn btn-primary btn-lg main-cta" @click="step='success'">
                        {{ t('pdv-save_sale') }}
                    </button>
                </div>
            </div>
            <div class="success" v-if="step==='success'">
                <div class="box">
                    <div class="text-center">
                        <h2>{{ t('pdv-sale_success') }}</h2>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-primary btn-lg main-cta" @click="step='client'">
                            {{ t('pdv-new_sale') }}
                        </button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>
<style scoped lang="scss">
.total-row {
    background: #ccc;
    font-weight: 500;
}

.products-table, .payment-block {
    width: 100%;
    overflow-x: auto;
    background: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
    border-radius: 10px;

    .table {
        width: 100%;
    }
}

.payment-block {
    padding: 1em;
}


.clients, .products, .payment {
    display: flex;
    flex-direction: column;
    gap: 1em;

    .add-product {
        background: #fff;
        font-size: 1.3rem;
    }

    .client, .product {
        display: flex;
        flex-direction: column;
        gap: 0.5em;
        padding: 1em;
        border: 1px solid #ccc;
        border-radius: 5px;
        cursor: pointer;
        transition: 0.3s;
        text-align: left;

        &:hover {
            background-color: #f9f9f9;
        }
    }
}

.input-button {
    display: flex;
    gap: 1em;
    align-items: center;
}

.blocks {
    display: flex;
    flex-direction: column;
    gap: 2em;

    &.previous {
        background: #ffffff;
        box-shadow: 0 3px 8px rgba(0, 0, 0, .25);
        border-radius: 10px;

        button, .client {
            border: none;
        }
    }
}

.price {
    display: flex;
    justify-content: flex-end;
    gap: 1em;
    align-items: center;

    input {
        width: 100px;
    }
}

.payment {
    label {
        flex-basis: 150px;
    }
}
</style>
<script>
import Modal from "../components/modal/modal";

export default {
    name: 'Pdv',
    components: {Modal},
    data() {
        return {
            client: "",
            newClient: false,
            step: "client", //client, products, payment
            timeout: null,
            products: [],
            productsSearch: "",
            total: 0
        }
    },
    mounted() {
        this.setTimeout();
        //clear timeout if anykey is pressed or mouse moved
        window.addEventListener('keydown', () => {
            clearTimeout(this.timeout);
        });
        window.addEventListener('mousemove', () => {
            clearTimeout(this.timeout);
        });
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        formatCurrency(value) {
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL",
            }).format(Number(value || 0));
        },
        setTimeout() {
            this.timeout = setTimeout(() => {
                window.location.reload();
            }, 3000);
        },
        closeProductModal() {
            this.$refs.modal.close();
        },
        openProductModal() {
            this.$refs.modal.open();
        },
        addProduct() {
            this.products.push({
                name: this.t("pdv-product_1"),
                price: 10.00,
                quantity: 1,
                subtotal: 10.00
            });
            this.productsSearch = "";
            this.step = 'products-list'
            this.closeProductModal();
        }
    },
    watch: {
        products: {
            handler() {
                this.total = this.products.reduce((acc, product) => acc + product.subtotal, 0);
            },
            deep: true
        }
    }
}
</script>
